import React from 'react';
import { CoffeeIcon, CreditCardIcon, ShieldCheckIcon, TvIcon, WifiIcon, WrenchIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { TikTokTips } from './TikTokTips';
const amenities = [{
  icon: WifiIcon,
  title: 'Free guest Wi-Fi',
  copy: 'Work or stream while you wait in the customer lounge.'
}, {
  icon: TvIcon,
  title: 'TV & coffee bar',
  copy: 'A comfortable waiting room with TV and coffee while we work.'
}, {
  icon: WrenchIcon,
  title: 'Modern diagnostic equipment',
  copy: 'Up-to-date, cutting-edge tooling backed by FCA Chrysler, Dodge and Jeep factory training.'
}, {
  icon: ShieldCheckIcon,
  title: '1 year / 12,000 mile warranty',
  copy: 'Parts and labor covered on the repairs we perform.'
}, {
  icon: CreditCardIcon,
  title: 'Financing options available',
  copy: 'Snap Finance, Affirm, Klarna and Sunbit. Ask us when a repair is larger than expected.'
}, {
  icon: CoffeeIcon,
  title: 'Straight answers, every visit',
  copy: 'You will always know what we found, what it costs, and what can wait.'
}];
export function ShopExperience() {
  return <section id="shop-experience" className="w-full bg-chalk py-20 lg:py-28" data-id="element-384" data-mp="3a67vhpekzyts">
      <div className="mx-auto max-w-shell px-5 lg:px-8" data-id="element-385" data-mp="3a8avn29g78c8">
        <div className="grid gap-12 lg:grid-cols-[minmax(0,1fr)_minmax(0,440px)] lg:items-start lg:gap-16" data-id="element-386" data-mp="3e8b9akoq3fi8">
          <div data-id="element-387" data-mp="5s9srejdat7e">
            <p className="text-[12px] font-bold uppercase tracking-[0.18em] text-brand-dark" data-id="element-388" data-mp="5tt91550x496">
              The shop
            </p>
            <h2 className="mt-4 max-w-[520px] font-display text-[34px] font-extrabold leading-[1.08] tracking-[-0.02em] text-ink sm:text-[42px]" data-id="element-389" data-mp="3t52amzhyj1ah">
              A shop built around the customer, not just the car
            </h2>
            <p className="mt-5 max-w-[540px] text-[16.5px] leading-relaxed text-steel/75" data-id="element-390" data-mp="opjc6vop06on">
              Over 55 years of combined technician experience, modern equipment
              and a waiting room you will not mind sitting in.
            </p>

            <ul className="mt-10 grid gap-x-8 gap-y-7 sm:grid-cols-2" data-id="element-391" data-mp="13ayjgoyrw5wb">
              {amenities.map(item => <li key={item.title} className="flex gap-3.5" data-id="element-392" data-mp="ucctw9uvvqm1">
                  <item.icon className="mt-0.5 h-5 w-5 shrink-0 text-brand-dark" aria-hidden="true" data-id="element-393" data-mp="uas0woo7wfqa" />
                  <div data-id="element-394" data-mp="keow1b1ze2zn">
                    <h3 className="font-display text-[16px] font-bold tracking-tight text-ink" data-id="element-395" data-mp="kg01rgezlkte">
                      {item.title}
                    </h3>
                    <p className="mt-1 text-[14px] leading-relaxed text-steel/70" data-id="element-396" data-mp="bllofje0okcx">
                      {item.copy}
                    </p>
                  </div>
                </li>)}
            </ul>

            <Link to="/financing" className="mt-8 inline-block text-[12.5px] font-bold uppercase tracking-[0.08em] text-brand-dark hover:underline" data-id="element-397" data-mp="1o7b3sne4bou">
              See financing options
            </Link>
          </div>

          <TikTokTips data-id="element-398" data-mp="3npelvnx6fgin" />
        </div>
      </div>
    </section>;
}